import React from "react";
import SuperBuildUpHero from "./SuperBuildUpHero";
import SpClientrequirements from "./SpClientrequirements";
import SpSolution from "./SpSolution";
import A2PortfolioTechStack from "../Components/A2PortfolioTechStack";
import SpSalesDashboard from "./SpSalesDashboard";
import SpCta from "./SpCta";
import SpDashboard from "./SpDashboard";
import SpBoottom from "./SpBoottom";
import SpLast from "./SpLast";
import HelmetMetaTag from "../Components/HelmetMetaTag";

export default function SuperBuildup() {
  const slides = [
    {
      title: "Frontend",
      logos: [
        "frontendlogo1.png",
        "frontendlogo5.png",
        "frontendlogo6.png",
        "frontendlogo7.png",
      ],
    },
    {
      title: "Backend",
      logos: ["backendlogo5.png"],
    },
    {
      title: "Database",
      logos: ["database2.png"],
    },
    {
      title: "Payment & API Integration",
      logos: ["Whatsapp.png", "SMTP.png"],
    },
  ];
  return (
    <React.Fragment>
      <HelmetMetaTag
        titleName="Modern real estate ERP system - SprigStack"
        desc="Superbuildup is a real estate ERP system for builders. Sprigstack has developed this ERP to manage sales, on site and financial operations in one software."
        canonical={window.location.href}
        ogtitle="Modern real estate ERP system - SprigStack"
        ogdesc="Superbuildup is a real estate ERP system for builders. Sprigstack has developed this ERP to manage sales, on site and financial operations in one software."
        ogtype="website"
        ogurl={window.location.href}
      />
      <SuperBuildUpHero />
      <SpClientrequirements />
      <SpSolution />
      <A2PortfolioTechStack
        slides={slides}
        Color="super-buildup-clr-b-2B3A99"
        headingColor="super-buildup-clr-2B3A99"
      />
      <SpSalesDashboard />
      <SpCta />
      <SpDashboard />
      <SpLast />
      <SpBoottom />
    </React.Fragment>
  );
}
